import React from 'react';
import { Draggable } from '@hello-pangea/dnd';

function KanbanCard({ lead, index, onClick }) {
  const scoreClass = lead.score >= 80 ? 'high' : lead.score >= 60 ? 'medium' : 'low';

  return (
    <Draggable draggableId={lead._id} index={index}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          className={`kanban-card ${snapshot.isDragging ? 'dragging' : ''}`}
          onClick={() => onClick(lead)}
        >
          <div className="kanban-card-name">{lead.name || 'Unknown'}</div>
          <div className="kanban-card-company">
            {lead.company || lead.enrichment?.company || ''}
          </div>
          <div className="kanban-card-email">{lead.email || ''}</div>
          <div className="kanban-card-footer">
            <span className={`kanban-card-score ${scoreClass}`}>
              {lead.score ?? 0}
            </span>
            <span className="kanban-card-assigned">
              {lead.assigned_to || ''}
            </span>
          </div>
        </div>
      )}
    </Draggable>
  );
}

export default KanbanCard;
